import { render, staticRenderFns } from "./PorudzbeDostava.vue?vue&type=template&id=57ba0274&scoped=true"
import script from "./PorudzbeDostava.vue?vue&type=script&lang=js"
export * from "./PorudzbeDostava.vue?vue&type=script&lang=js"
import style0 from "./PorudzbeDostava.vue?vue&type=style&index=0&id=57ba0274&prod&lang=css"
import style1 from "./PorudzbeDostava.vue?vue&type=style&index=1&id=57ba0274&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ba0274",
  null
  
)

export default component.exports